const Guide = (props) => {
    const { customBodyType } = props;

    return (
        <>
            <div className="container">
                <span className="modal_title_guide" id="staticBackdropLabel">CUSTOMISE</span>
                <p className="guide_description">This kurta can be customized for a perfect fit tailor made especially for you. </p>
                <p className="guide_description mt-4">Select your body type:</p>
                <div>
                    <div className="form-group">
                        <div className="custom_size_popup_content_type">
                            <div className="custom_size_popup_content_type_inner row">
                                {customBodyType?.map((item, index) => {
                                    return (
                                        <div
                                            key={index}
                                            className={`custom_size_popup_content_type_inner_flex col-sm-3 col-4 d-flex justify-content-center`}
                                        >
                                            <div className={`selected`}>
                                                <img src={item?.image} alt="Hand-stitched embroidered kurta – Gailee"/>
                                                <p className="body_type_name">{item?.type}</p>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>

                    <div className="instructions my-3">
                        <h6>Guide:</h6>
                        <ul>
                            <li><strong>Triangle (Pear-shaped):</strong> My hips are wider than my bust.</li>
                            <li><strong>Inverted Triangle:</strong> My shoulders are broad and taper down to narrower hips.</li>
                            <li><strong>Round (Apple-shaped):</strong> My midsection is fuller with a softer, rounded shape.</li>
                            <li><strong>Rectangle:</strong> I have a straight, balanced frame where my bust, waist, and hips have similar measurements.</li>
                            <li><strong>Hourglass:</strong> I have balanced proportions with a well-defined waist, where the bust and hips are nearly equal in width.</li>
                        </ul>
                    </div>

                    <h6>Customized Measurements:</h6>
                    <div className="Measurements">
                        <ol>
                            <li>1. Bust in inches- (insert number)</li>
                            <li>2. Waist - (insert number in inches)</li>
                            <li>3. Hips - (insert number)</li>
                            <li>4. Shoulder - (insert number)</li>
                            <li>5. Height- in inches/ feet</li>
                            <li>6. Sleeve length (optional) – in inches</li>
                        </ol>
                    </div>
                </div>

                <div className="note_guide">
                    <p><strong>Note:</strong> Customized orders must be prepaid and will be shipped within 7-14 days.<br /> Kindly contact us for additional information on <a href="tel:+918756562626" title="About Gailee – Learn about our brand">+91-8756562626</a>.</p>
                </div>

                <div className="instructions measure_body_main mt-4">
                    <h5>How to Measure:</h5>
                    <p className="measure_body">To measure your body correctly, follow these steps using a <strong>soft measuring tape</strong> and wear fitted clothing or measure over bare skin for accuracy:</p>
                    <ol>
                        <li><strong>Bust:</strong> Wrap the tape around the fullest part of your bust, keeping it level across your back and snug but not tight.</li>
                        <li><strong>Waist:</strong> Find your natural waistline, usually the narrowest part of your torso (just above the belly button). Breathe normally and keep the tape slightly loose for comfort.</li>
                        <li><strong>Hips:</strong> Measure around the fullest part of your hips and buttocks, ensuring the tape is straight and not digging in.</li>
                        <li><strong>Shoulders:</strong> Measure from shoulder edge to shoulder edge across your back while standing straight.</li>
                    </ol>
                    <h4>Tips:</h4>
                    <ul>
                        <li>Keep the tape <strong>parallel to the floor</strong> at all times.</li>
                        <li>Stand <strong>naturally</strong> without sucking in or pushing out.</li>
                        <li>Measure <strong>twice</strong> to ensure accuracy!</li>
                    </ul>
                </div>
            </div>
        </>
    )
}

export default Guide;